import WebSocket from 'reconnecting-websocket'
import {wsUri} from './core/websocketz'
import config from './config'

var frontWebSocket

function getFrontWebSocket() {
    if (!frontWebSocket) {
        const option = {
            minReconnectionDelay: 20000,
            maxReconnectionDelay: 20000,
            reconnectionDelayGrowFactor: 1
        }

        frontWebSocket = new WebSocket(wsUri(config.socket.front.url), config.socket.front.protocol, option)
    }
    return frontWebSocket
}

export default {getFrontWebSocket}


// WEBPACK FOOTER //
// ./lib/context.js